"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'LogisticsModal',
  props: {
    // 快递公司名称
    expressName: {
      type: String,
      default: ''
    },
    // 快递单号
    trackingNumber: {
      type: String,
      default: ''
    },
    // 物流信息数据
    logisticsInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    // 是否有物流信息数据
    hasLogisticsData: function hasLogisticsData() {
      return this.logisticsInfo.list && this.logisticsInfo.list.length > 0;
    }
  },
  data: function data() {
    return {
      visible: false // 弹窗是否显示
    };
  },
  methods: {
    open: function open() {
      this.visible = true;
      this.loading = true;
    },
    close: function close() {
      this.visible = false;
    }
  }
};